var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    on: {
      "blur": function($event) {
        _vm.focused = false
      },
      "focus": function($event) {
        _vm.focused = true
      }
    }
  }, [(!_vm.$slots.children) ? _vm._t("default", [_vm._v(_vm._s(_vm.children))]) : _vm._e(), _vm._v(" "), _vm._t("children")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e310fd26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e310fd26","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisConnectedItem.vue
// module id = 311
// module chunks = 0